import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ingredient-detail-sub-header',
  templateUrl: './ingredient-detail-sub-header.component.html',
  styleUrls: [
    './ingredient-detail-sub-header.component.scss',
    '../../../../styles/shared-mpp-styles.scss',
  ],
})
export class IngredientDetailSubHeaderComponent {
  @Input() selectedTab: string;
  @Input() showInfoIcon: boolean;
  constructor() {}

  shouldShowZeroCostIcon(): boolean {
    return this.showInfoIcon;
  }
}
